import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const t = sessionStorage.getItem("impersonation_token");
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  const bid = localStorage.getItem("active_business_id");
  if (bid && !config.url.startsWith("/auth/")) {
    config.params = { ...(config.params || {}), business_id: bid };
    if (config.data instanceof FormData) {
      config.data.set("business_id", bid);
    } else if (config.data && typeof config.data === "object" && !("business_id" in config.data)) {
      config.data = { ...config.data, business_id: bid };
    }
  }
  return config;
});

let refreshing = null;

API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const skip = ["/auth/login", "/auth/refresh", "/auth/register", "/auth/logout",
      "/auth/forgot-password", "/auth/reset-password"].some((p) => original?.url?.includes(p));
    if (error.response?.status === 401 && original && !original._retry && !skip) {
      original._retry = true;
      refreshing = refreshing || API.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return API(original);
      } catch (e) {
        sessionStorage.removeItem("impersonation_token");
        if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const data = e?.response?.data;
  const detail = data?.detail;
  if (detail == null) {
    if (typeof data === "string" && data.trim().startsWith("<")) {
      return `The server gateway returned an error (${e?.response?.status || "network"}). Please try again — if it persists, contact support.`;
    }
    return e?.message || "Something went wrong. Please try again.";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (typeof detail === "object") return detail.error || detail.msg || JSON.stringify(detail);
  return String(detail);
}
